export const htmlStringToElement = (html) => {
  var template = document.createElement('template');
  html = html.trim();
  template.innerHTML = html;
  return template.content.firstChild;
};

export const filterDuplicates = (array) => {
  return array.filter((e, i) => array.findIndex((a) => a['name'] === e['name']) === i);
};

export const removeTrailingZeros = (number) => {
  return parseFloat(number);
};

export const countDecimalPlaces = (number) => {
  const stringNumber = String(number);
  return stringNumber.split('.')[1].length;
};
